<template>
  <div class="navMargin">
    <NavBar :transparent-on-top="true" :scroll-padding="true"></NavBar>
    <vs-row align="center" justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6" sm="12" xs="12">
        <img src="https://media1.tenor.com/images/32b283c1427fb38836ecfd011354213f/tenor.gif" width="500px">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" w="6" direction="column" style="text-align: left;" sm="12" xs="12">
        <h1 style="margin: 0; margin-block-end: 0;">No encontramos su página :(</h1>
        <p style="margin: 0; margin-block-end: 0;">Lo sentimos: Aunque no tenemos más de 404 series en nuestra página, queremos ayudarte a encontrar lo que quieres.</p>
      </vs-col>
    </vs-row>
    <ul class="centrar">
      <li><vs-button href="/"><i class='bx bxs-home'></i> Volver al inicio</vs-button></li>
      <!-- <li><vs-button color="warn" href="/feedback/suggest"><i class='bx bxs-sun'></i> Sugerir serie</vs-button></li> -->
    </ul>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "./Footer";
import NavBar from "../components/NavBar";
export default {
  name: "NotFound",
  components: {NavBar, Footer},
  metaInfo() {
    return {
      title: 'Sitio desconocido - Videnti',
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf8' },
        { name: 'robots', content: 'noindex' }
      ]
    }
  }
}
</script>

<style scoped>
.contenido {
  padding-top: 10px;
}
.padeo {
  padding-top: 50px !important;
  margin-left: 2%;
  margin-right: 2%;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
